import Vue from "vue";
import axios from "axios";
import store from "../store";
import router from "@/router";
import { Message, Loading } from "element-ui";
import Cookies from "js-cookie";

let base = "";
if (process.env.NODE_ENV === "development") {
    // base = "http://192.168.0.17:8012"; //107
    // base = "http://192.168.0.17:8012/test"; //17
    // base = "https://api.fjdaze.com/";
    // base = "http://api.fjdaze.com";
    base = " https://test-api.fjdaze.com/"; //测试
} else {
    if (location.host.includes("test.kuaio.cn")) {
        base = " https://test-api.fjdaze.com/";
    } else if (location.host.includes("192.168.0.107:8416")) {
        base = "http://192.168.0.17:8012";

        // base = "http://test-api.fjdaze.com/";
    } else if (location.host.includes("192.168.0")) {
        base = "http://192.168.0.17:8012";
        // base = 'http://test-api.fjdaze.com/'
    } else {
        base = "https://api.fjdaze.com/";
    }
}
/* axios.defaults.withCredentials=true  */
let ajax = axios.create({
    baseURL: base,
    timeout: 60000,
});

/*****  获取cookie  *****/
function getCookie(key) {
    let arr1 = document.cookie.split("; "); //cookie是通过一个分号+空格的形式串联起来的，所以这里需要先按分号空格截断
    for (let i = 0; i < arr1.length; i++) {
        let arr2 = arr1[i].split("=");
        if (arr2[0] == key) {
            return decodeURI(arr2[1]);
        }
    }
}

if (getCookie("S_KuaiO_A_Key")) {
    localStorage.setItem("accessToken", getCookie("S_KuaiO_A_Key"));
}

let cancelToken = axios.CancelToken;
let source = cancelToken.source();
// 添加请求拦截器
ajax.interceptors.request.use(
    async function (config) {
        //store.commit("setLoginVisible", false);
        let token = undefined;
        //token="a91a846c317945e7ae48ba14370ac23a";//大泽网络
        // token="629c37c11af8437fb268d18710e3e14c";//01账号
        //token = "fa763561620f4dca974acd17ae14a13f"; //03
        //token = 'e246f9fb320a411facbf3dc77f8875d4' //02
        //token = '9eaa9de098104b08a394a69ac752e917' // 17 02
        //token = 'd1c4524d30ae41a2aebb19f331054be6' // 17 03
        //token="6ba0239b437141c880dc0aed3e5be26a";//04 17
        //token="6ba0239b437141c880dc0aed3e5be26a" //大泽网络 17
        /* if (!token) {
      token = getCookie("S_KuaiO_A_Key");
    } */
        if (!token) {
            let userInfo = localStorage.getItem("userInfo");
            if (userInfo) {
                userInfo = JSON.parse(userInfo);
                if (userInfo.token) token = userInfo.token;
            }
        }
        if (token) {
            config.headers.common["token"] = token;
        }

        if (
            config.url.startsWith("/payment") ||
            config.url.startsWith("payment")
        ) {
            config.headers.common["Authorization"] = await getPayPackageToken();
        }

        config.cancelToken = new cancelToken((c) => {
            //回调回去取消方法
            if (config.params) {
                config.params.abort && config.params.abort(c);
            } else if (config.abort) {
                config.abort(c);
            }
        });
        if (config.params && config.params.abort) {
            delete config.params.abort;
        } else if (config.abort) {
            delete config.abort;
        }
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
ajax.interceptors.response.use(
    function (res) {
        // 对响应数据做点什么
        let data = res.data;
        if (data.hasOwnProperty("code")) {
            let { code } = data;
            switch (code) {
                case 200:
                    // Promise.resolve(data);
                    return data;
                    break;
                case 5000:
                    if (data.msg == "授权已失效，请重新登录") {
                        Message.error(data.msg);
                        localStorage.removeItem("userInfo");
                        store.commit("delUserPhone");
                        store.state.loginMode = 1;
                        store.commit("setLoginVisible", true);
                        Loading.close();
                    }
                    return data;
                    break;
                default:
                    return data;
                    break;
            }
        } else {
            return data;
        }
    },
    function (error) {
        let time = new Date();
        // console.log("1233")
        function fileTime(v) {
            let str = "";
            return (str = v < 10 ? "0" + v : v);
        }
        // // console.log(this, Vue, axios)
        let formatTime =
            fileTime(time.getFullYear()) +
            "-" +
            fileTime(time.getMonth() + 1) +
            "-" +
            fileTime(time.getDate()) +
            " " +
            fileTime(time.getHours()) +
            ":" +
            fileTime(time.getMinutes()) +
            ":" +
            fileTime(time.getSeconds());
        let userInfo = localStorage.getItem("userInfo");
        userInfo = JSON.parse(userInfo);
        axios.post(base + "/logmanage/api/Log/Add", {
            level:
                error.config.url === "/kuaio/api/Member/Login/Login"
                    ? "3"
                    : "4", //日志等级
            projectName: "kuaio", //项目名称
            userid: userInfo ? userInfo.token : "身份游客暂无token", //请求的用户token
            message: JSON.stringify(error.message), //日志标题信息(255字节)
            detailTrace: JSON.stringify(error.stack), //日志细节跟踪
            logTime: formatTime, //日志记录时间
            requestUrl: error.config.url, //请求地址
            params: error.config.data, //请求参数
            tag: "报错页面路径:" + router.history.current.path, //报错页面
            func: "快哦前端",
        });
        // 对响应错误做点什么
        if (error && error.response) {
            switch (error.response.status) {
                /* case 404:
          //router.push({name:'error-404'});
          break; */
                case 500:
                    router.push({ name: "error500" });
                    break;
            }
        }
        return Promise.reject(error);
    }
);

function getPayPackageToken() {
    const authorization = Cookies.get("authorization");
    if (authorization) {
        return authorization;
    }

    return fetchPayPackageToken();
}

function fetchPayPackageToken() {
    return ajax
        .post("/trafficPromotion/api/v1/PayPackage/GetPayPackageToken")
        .then((res) => {
            if (res.code === 200) {
                const expires = new Date(
                    Date.now() + (2 * 60 * 60 * 1000 - 60000)
                );
                Cookies.set("authorization", res.result, { expires });
                return res.result;
            }
        });
}

Vue.prototype.$ajax = ajax;
export default ajax;
